import React, { useState, useRef, useEffect } from "react";
import { Paperclip, X } from "lucide-react"; 
import "../css/AddTemplate.css";
import axios from "axios";


const EditTemplate = ({ templateData, onClose, onSaved }) => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [formData, setFormData] = useState({
    name: "",
    subject: "",
    body: "",
    files: [],
    group_id: "",
    competition_id: "",
  });

  const [activeCompetitionId, setActiveCompetitionId] = useState(null); 
  const editorRef = useRef(null);
  const fileInputRef = useRef(null);

  // Placeholders available
  const placeholders = ["{{fullname}}","{{name}}","{{mname}}",  "{{lname}}","{{email}}",  "{{competition}}","{{address1}}", "{{address2}}" ,"{{phone1}}","{{phone2}}",
    "{{username}}", "{{password}}", 
  ];



 

  useEffect(() => {
    if (templateData && templateData._id) {
      setFormData({
        name: templateData.name || "",
        subject: templateData.subject || "",
        body: templateData.body || "",
        files: templateData.attachments || [],
        competition_id: templateData.competition_id || activeCompetitionId || "",
      });

      if (editorRef.current) {
        editorRef.current.innerHTML = templateData.body || "";
      }
    } else {
      if (editorRef.current) editorRef.current.innerHTML = "";
    }
  }, [templateData, activeCompetitionId]);

  const handleChange = () => {
    if (editorRef.current) {
      setFormData((prev) => ({
        ...prev,
        body: editorRef.current.innerHTML,
      }));
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const text = e.clipboardData.getData("text/plain");
    document.execCommand("insertText", false, text);
  };

  // Insert placeholder at cursor
  const insertPlaceholder = (ph) => {
    if (editorRef.current) {
      editorRef.current.focus();
      document.execCommand("insertText", false, ph);
      handleChange();
    }
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      files: [...prev.files, ...Array.from(e.target.files)],
    }));
  };

  const removeFile = (index) => {
    setFormData((prev) => ({
      ...prev,
      files: prev.files.filter((_, i) => i !== index),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = new FormData();
      payload.append("name", formData.name.trim());
      payload.append("subject", formData.subject.trim());
      payload.append(
        "body",
        editorRef.current ? editorRef.current.innerHTML.trim() : formData.body.trim()
      );
      payload.append("group_id", formData.group_id);

      if (formData.competition_id) {
        payload.append("competition_id", formData.competition_id);
      } else if (activeCompetitionId) {
        payload.append("competition_id", activeCompetitionId);
      }

      formData.files.forEach((file) => {
        if (file instanceof File) payload.append("files", file);
      });

      if (templateData && templateData._id) {
        await axios.put(`${API_URL}/ems/templates/${templateData._id}`, payload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      } else {
        await axios.post(`${API_URL}/ems/templates`, payload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      alert("Template saved successfully!");
      onSaved?.();
      onClose?.();
    } catch (err) {
      console.error("Error saving template:", err.response?.data || err.message);
    }
  };

  if (!templateData) return null;

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0,0,0,0.3)" }}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
    >
      <div
        className="modal-dialog modal-lg"
        role="document"
        style={{ margin: "40px auto" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content" style={{ borderRadius: "12px", border: "1px solid #ddd" }}>
          <form onSubmit={handleSubmit}>
            {/* Header */}
            <div className="modal-header" style={{ borderBottom: "1px solid #eee", padding: "10px 15px" }}>
              <h6 style={{ margin: 0, fontWeight: "600" }}>
                {templateData._id ? "Edit Template" : "Add Template"}
              </h6>
              <button type="button" className="btn-close" onClick={onClose}></button>
            </div>

            {/* Body */}
            <div className="modal-body" style={{ padding: "10px 15px" }}>
              <input
                type="text"
                className="form-control border-0 border-bottom mb-3"
                placeholder="Template Name"
                value={formData.name}
                onChange={(e) => setFormData((prev) => ({ ...prev, name: e.target.value }))}
                required
              />
              {/* <input
                type="text"
                className="form-control border-0 border-bottom mb-3"
                placeholder="Template Subject"
                value={formData.subject}
                onChange={(e) => setFormData((prev) => ({ ...prev, subject: e.target.value }))}
                required
              /> */}

              {/* Placeholder buttons */}
              <div className="mb-2" style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                {placeholders.map((ph, idx) => (
                  <button
                    key={idx}
                    type="button"
                    className="btn btn-sm"
                    style={{
                      borderRadius: "12px",
                      border: "1px solid #ccc",
                      background: "#f8f9fa",
                      fontSize: "12px",
                      padding: "2px 8px",
                    }}
                    onClick={() => insertPlaceholder(ph)}
                  >
                    {ph}
                  </button>
                ))}
              </div>

              {/* Editor */}
              <div
                ref={editorRef}
                contentEditable
                suppressContentEditableWarning
                style={{
                  minHeight: "200px",
                  border: "1px solid #ccc",
                  padding: "8px",
                  marginBottom: "8px",
                  whiteSpace: "pre-wrap",
                }}
                onInput={handleChange}
                onPaste={handlePaste}
              />

              <div className="d-flex align-items-center mt-2" style={{ gap: "8px" }}>
                <button
                  type="button"
                  className="btn btn-sm"
                  style={{ background: "transparent", border: "none", color: "#D9A128", cursor: "pointer" }}
                  onClick={() => fileInputRef.current?.click()}
                >
                  <Paperclip size={18} /> Attach
                </button>
                <input type="file" multiple ref={fileInputRef} style={{ display: "none" }} onChange={handleFileChange} />
                <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                  {formData.files.map((file, idx) => (
                    <span
                      key={idx}
                      style={{
                        background: "#f1f3f4",
                        borderRadius: "12px",
                        padding: "2px 6px",
                        fontSize: "12px",
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      {file.filename || file.name}
                      <X size={12} style={{ cursor: "pointer" }} onClick={() => removeFile(idx)} />
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="modal-footer d-flex justify-content-between" style={{ padding: "10px 15px", borderTop: "1px solid #eee" }}>
              <button type="submit" className="btn" style={{ backgroundColor: "#D9A128", color: "white", borderRadius: "20px", padding: "6px 18px" }}>
                Save
              </button>
              <button type="button" className="btn btn-sm" style={{ backgroundColor: "transparent", color: "#555" }} onClick={onClose}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditTemplate;
